import IconDetails from "@mui/icons-material/Visibility";
import Button from "../../ui/button";
import wrapperButtonForRedirect from "../../hoc/wrapperButtonForRedirect";

function DetailsButton({ onClick })
{
  return (
    <Button label="Detalhes" color="primary" onClick={onClick}>
      <IconDetails />
    </Button>
  );
}

export default wrapperButtonForRedirect(DetailsButton, "show");
